/** Shared domain types. Mirrors the database schema (supabase/migrations). */

export type Locale = 'th' | 'en' | 'my';
export type Zone = 'upper_left' | 'upper_right' | 'lower_left' | 'lower_right';
export type KickSource = 'tap' | 'session';
/** 'lifetime' is what we sell (299 THB once). 'month'/'year' only exist on old rows. */
export type Plan = 'lifetime' | 'month' | 'year';
export type EntitlementStatus = 'trial' | 'paid' | 'free';

export interface Profile {
  displayName: string;
  babyNickname: string | null;
  dueDate: string;            // YYYY-MM-DD (local date)
  locale: Locale;
  timezone: string;
  hospitalPhone: string | null;
  soundOn: boolean;
  reminderEnabled: boolean;
  reminderTime: string;       // HH:MM
}

export interface Kick {
  clientId: string;           // generated on device → idempotent sync
  occurredAt: number;         // epoch ms
  source: KickSource;
  sessionClientId: string | null;
  zone: Zone | null;
  x: number | null;
  y: number | null;
  z: number | null;
}

export interface CountSession {
  clientId: string;
  startedAt: number;
  endedAt: number | null;
  kickCount: number;
  reachedTarget: boolean;
  lowMovementFlag: boolean;
  note: string | null;
}

export interface Entitlement {
  status: EntitlementStatus;
  trialEndsAt: number | null;
  paidUntil: number | null;
  plan: Plan | null;
  /** server time minus device time, ms. Used so a wrong phone clock can't change access. */
  clockSkewMs: number;
}

export const hasPremium = (e: Entitlement | null): boolean => !!e && e.status !== 'free';
